import { request } from './utils';

export default class MailSoarService {
    static async sendTestEmails() {
        const response = await request('/api/mail_soar/send_test_email', { method: 'POST' });

        return response;
    }
}
